(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[459],{

/***/ 83236:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(67389);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 58944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layouts_Layout; }
});

// UNUSED EXPORTS: VerticalAlign

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./styles/modules/Layout.module.scss
var Layout_module = __webpack_require__(87383);
var Layout_module_default = /*#__PURE__*/__webpack_require__.n(Layout_module);
// EXTERNAL MODULE: ./components/context/AppContext.tsx + 6 modules
var AppContext = __webpack_require__(90995);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/scripts/Userback.tsx



var Userback = function(param) {
    var userEmail = param.userEmail, userName = param.userName, customButton = param.customButton;
    var email = userEmail || "";
    var name = userName || "";
    var customConfig = "";
    if (customButton) {
        customConfig = '\n      var body = document.body;\n      window.Userback.on_open = () => {\n        body.classList.add("open");\n      };\n      window.Userback.on_close = () => {\n        body.classList.remove("open");\n      };\n      Userback.before_send = function() {\n        body.classList.remove("open");\n      };\n    ';
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
            id: "user-back",
            strategy: "lazyOnload",
            children: "\n        window.Userback = window.Userback || {};\n        ".concat(customConfig, '\n        Userback.access_token = "32636|59886|fNDPDbiTeNkA7ELMFXQxLdHp2";\n        (function (d) {\n          var s = d.createElement("script");\n          s.async = true;\n          s.src = "https://static.userback.io/widget/v1.js";\n          (d.head || d.body).appendChild(s);\n        })(document);\n          window.Userback.name = "').concat(name, '";\n          window.Userback.email = "').concat(email, '";\n      ')
        })
    });
};


// EXTERNAL MODULE: ./node_modules/lodash/capitalize.js
var capitalize = __webpack_require__(48403);
var capitalize_default = /*#__PURE__*/__webpack_require__.n(capitalize);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./styles/modules/TopNav.module.scss
var TopNav_module = __webpack_require__(31757);
var TopNav_module_default = /*#__PURE__*/__webpack_require__.n(TopNav_module);
// EXTERNAL MODULE: ./node_modules/pong-react-components/assets/images/icons/products/icon-companynetwork.svg
var icon_companynetwork = __webpack_require__(52998);
var icon_companynetwork_default = /*#__PURE__*/__webpack_require__.n(icon_companynetwork);
// EXTERNAL MODULE: ./node_modules/pong-react-components/assets/images/icons/products/icon-product-connect.svg
var icon_product_connect = __webpack_require__(60736);
var icon_product_connect_default = /*#__PURE__*/__webpack_require__.n(icon_product_connect);
// EXTERNAL MODULE: ./node_modules/pong-react-components/assets/images/icons/products/icon-product-prism.svg
var icon_product_prism = __webpack_require__(81067);
var icon_product_prism_default = /*#__PURE__*/__webpack_require__.n(icon_product_prism);
// EXTERNAL MODULE: ./node_modules/pong-react-components/assets/images/icons/products/icon-product-spaces.svg
var icon_product_spaces = __webpack_require__(37996);
var icon_product_spaces_default = /*#__PURE__*/__webpack_require__.n(icon_product_spaces);
// EXTERNAL MODULE: ./node_modules/pong-react-components/assets/images/icons/products/icon-product-studio.svg
var icon_product_studio = __webpack_require__(54782);
var icon_product_studio_default = /*#__PURE__*/__webpack_require__.n(icon_product_studio);
// EXTERNAL MODULE: ./node_modules/pong-react-components/assets/images/icons/products/icon-product-chat.svg
var icon_product_chat = __webpack_require__(89695);
var icon_product_chat_default = /*#__PURE__*/__webpack_require__.n(icon_product_chat);
// EXTERNAL MODULE: ./node_modules/pong-react-components/assets/images/icons/products/icon-product-datagraph.svg
var icon_product_datagraph = __webpack_require__(88135);
var icon_product_datagraph_default = /*#__PURE__*/__webpack_require__.n(icon_product_datagraph);
;// CONCATENATED MODULE: ./helpers/bundle.ts







var getIcon = function(bundleName) {
    switch(bundleName){
        case "apps":
            return (icon_companynetwork_default());
        case "connect":
            return (icon_product_connect_default());
        case "enterprise":
            return (icon_product_prism_default());
        case "spaces":
        case "space":
            return (icon_product_spaces_default());
        case "studio":
            return (icon_product_studio_default());
        case "chat":
            return (icon_product_chat_default());
        case "datagraph":
            return (icon_product_datagraph_default());
    }
};
var getTitle = function(bundleName) {
    switch(bundleName){
        case "apps":
            return "Pong Network";
        case "connect":
            return "Connect";
        case "enterprise":
            return "Pong Platform";
        case "spaces":
        case "space":
            return "Pong Prism";
        case "studio":
            return "Pong Studio";
        case "chat":
            return "Pong Circles";
        case "datagraph":
            return "CBI Datagraph";
    }
};

;// CONCATENATED MODULE: ./components/nav/TopNav.tsx





var TopNav = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref = (0,react.useState)(""), bundleName = ref[0], setBundleName = ref[1];
    (0,react.useEffect)(function() {
        setBundleName(window.location.hostname.split(".")[0]);
    }, []);
    var IconComponent = getIcon(bundleName);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: "sticky-top ".concat((TopNav_module_default())["top-nav"]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "".concat((TopNav_module_default())["bundle-icon"]),
                children: IconComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconComponent, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((TopNav_module_default())["app-title"]),
                children: getTitle(bundleName)
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/layouts/Layout.tsx







var VerticalAlign;
(function(VerticalAlign) {
    VerticalAlign["TOP"] = "v-top";
    VerticalAlign["MIDDLE"] = "v-middle";
    VerticalAlign["BOTTOM"] = "v-bottom";
})(VerticalAlign || (VerticalAlign = {}));
var Layout = function(param) {
    var children = param.children, title = param.title, useBrandBackground = param.useBrandBackground, _verticalAlign = param.verticalAlign, verticalAlign = _verticalAlign === void 0 ? VerticalAlign.TOP : _verticalAlign, embedClass = param.embedClass, userName = param.userName, userEmail = param.userEmail, hideUserBack = param.hideUserBack;
    var variableState = (0,AppContext/* useAppContext */.bp)().variableState;
    var clientName = variableState.clientName || "";
    var brandClassName = useBrandBackground ? (Layout_module_default())[clientName] : "";
    var ogTitle = clientName ? "".concat(capitalize_default()(variableState.clientName), " Connect") : "Pong Enterprise";
    var imagePath = clientName ? "".concat(clientName, "_connect.jpg") : "pong_enterprise.jpg";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "\n      ".concat((Layout_module_default()).container, "\n      ").concat((Layout_module_default())[verticalAlign], "\n      ").concat(brandClassName, "\n    "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title || "Welcome to ".concat(capitalize_default()(variableState.clientName), " onPong!")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width,minimum-scale=1,initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "sentry-trace",
                        content: "{{ span.toSentryTrace() }}"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "shortcut icon",
                        href: "/favicon.ico"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico",
                        sizes: "16x16 32x32 48x48 64x64"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: ogTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: ogTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "/".concat(imagePath)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:type",
                        content: "image/png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:width",
                        content: "400"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:height",
                        content: "300"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:alt",
                        content: ogTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:title",
                        content: ogTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:image",
                        content: "/".concat(imagePath)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: "/favicon-16.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: "/favicon-32.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "64x64",
                        href: "/favicon-64.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "128x128",
                        href: "/favicon-128.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "512x512",
                        href: "/favicon-512.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "120x120",
                        href: "/apple-touch-icon-120.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "152x152",
                        href: "/apple-touch-icon-152.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: "/apple-touch-icon-180.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "mask-icon",
                        href: "/safari-pinned-tab.svg",
                        color: "#724ae2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "apple-mobile-web-app-title",
                        content: ogTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-TileColor",
                        content: "#724ae2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-TileColor",
                        content: "windows-tile-144.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-config",
                        content: "browserconfig.xml"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "manifest",
                        href: "/site.webmanifest"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "application-name",
                        content: "Pong"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "theme-color",
                        content: "#724ae2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Userback, {
                userName: userName,
                userEmail: userEmail,
                customButton: hideUserBack
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopNav, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: "".concat(embedClass || "", " ").concat((Layout_module_default()).main),
                children: children
            })
        ]
    });
};
/* harmony default export */ var layouts_Layout = (Layout);


/***/ }),

/***/ 67389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ login_Login; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/layouts/Layout.tsx + 3 modules
var Layout = __webpack_require__(58944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(42283);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(36219);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./styles/modules/Form.module.scss
var Form_module = __webpack_require__(10315);
var Form_module_default = /*#__PURE__*/__webpack_require__.n(Form_module);
;// CONCATENATED MODULE: ./components/auth/LoginForm.tsx










var schema = es/* object */.Ry().shape({
    email: es/* string */.Z_().email().required(),
    password: es/* string */.Z_().required(),
    savelogin: es/* boolean */.O7()
});
// Move this into a helper function
var getLogin = function() {
    var storedEmail = "";
    if ( true && window.localStorage) {
        var storage = window.localStorage;
        storedEmail = storage.getItem("remember");
    }
    return storedEmail;
};
var saveLogin = function(email) {
    if ( true && window.localStorage) {
        var storage = window.localStorage;
        storage.setItem("remember", email);
    }
};
var clearLogin = function() {
    if ( true && window.localStorage) {
        var storage = window.localStorage;
        storage.removeItem("remember");
    }
};
var Login = function(props) {
    var ref = (0,react.useState)(false), showpwd = ref[0], setShowpwd = ref[1];
    var showPasswordToggle = function() {
        setShowpwd(!showpwd);
    };
    var defaultValues = {
        email: getLogin() || "",
        password: "",
        savelogin: true
    };
    var ref1 = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup_module/* yupResolver */.X)(schema),
        defaultValues: defaultValues,
        mode: "onChange"
    }), register = ref1.register, handleSubmit = ref1.handleSubmit, formState = ref1.formState, clearErrors = ref1.clearErrors, watch = ref1.watch;
    var errors = formState.errors;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (data.savelogin) {
                            saveLogin(data.email);
                        } else {
                            clearLogin();
                        }
                        props.loginRequest(data);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var emailField = watch("email");
    var passwordField = watch("password");
    var onBlur = function() {
        if (emailField === defaultValues.email && passwordField === defaultValues.password) {
            clearErrors([
                "email",
                "password"
            ]);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "".concat((Form_module_default()).login),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "d-flex flex-column content",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                className: "".concat((Form_module_default())["auth-container"]),
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "email",
                                className: "form-label",
                                children: "Email Address"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "form-group__fields",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "hidden",
                                        autoComplete: "off"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        type: "email",
                                        className: "form-control auth-input ".concat(errors.email ? "is-invalid" : "")
                                    }, register("email")), {
                                        defaultValue: "",
                                        autoComplete: "off",
                                        onBlur: onBlur
                                    }))
                                ]
                            }),
                            errors.email && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "form-error",
                                children: errors.email.message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "form-group mt-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "password",
                                className: "form-label",
                                children: "Password"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "password-toggle",
                                onClick: showPasswordToggle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa ".concat(showpwd ? "fa-eye-slash" : "fa-eye", " ")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "password-toggle-label",
                                        children: showpwd ? "Hide" : "Show"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "form-group__fields",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    type: showpwd ? "text" : "password",
                                    className: "form-control auth-input auth-pwd",
                                    defaultValue: "",
                                    autoComplete: "off"
                                }, register("password")), {
                                    onBlur: onBlur
                                }))
                            }),
                            errors.password && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "form-error",
                                children: errors.password.message
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "auth-message-container",
                                children: props.loginError && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "form-group__fields--error",
                                    children: props.loginError
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((Form_module_default())["form-actions"]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "submit",
                                className: "btn btn-purple auth-button mb-3",
                                disabled: !formState.isValid,
                                "data-testid": "btn-sign-in",
                                children: "Sign In"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((Form_module_default())["save-user"]),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                        name: "savelogin",
                                        type: "checkbox"
                                    }, register("savelogin"))),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "save-login",
                                        children: "Save my info for future log-ins"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((Form_module_default()).links),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "forgot-password",
                                        className: "".concat((Form_module_default())["text-link-children"]),
                                        children: "Reset Password"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "request-account",
                                        className: "".concat((Form_module_default())["text-link-children"]),
                                        children: "Request an Account"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var LoginForm = (Login);

// EXTERNAL MODULE: ./styles/modules/Footer.module.scss
var Footer_module = __webpack_require__(8632);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
;// CONCATENATED MODULE: ./components/footer/FooterLinks.tsx


var FooterLinks = function() {
    var year = new Date().getFullYear();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Footer_module_default()).footer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (Footer_module_default()).copyright,
                children: [
                    "Copyright \xa9 ",
                    year,
                    " Pong Labs, LLC All rights reserved."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://www.pong.ai/privacy",
                target: "_blank",
                rel: "noreferrer",
                className: (Footer_module_default()).link,
                children: "Privacy Policy"
            })
        ]
    });
};
/* harmony default export */ var footer_FooterLinks = (FooterLinks);

// EXTERNAL MODULE: ./styles/modules/Index.module.scss
var Index_module = __webpack_require__(78378);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
;// CONCATENATED MODULE: ./pages/login.tsx








var signin = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(email, password) {
        var response, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetch("/api/v1/auth/login", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        credentials: "include",
                        body: JSON.stringify({
                            email: email,
                            password: password
                        })
                    });
                case 2:
                    response = _ctx.sent;
                    _ctx.next = 5;
                    return response.json();
                case 5:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function signin(email, password) {
        return _ref.apply(this, arguments);
    };
}();
var __N_SSP = true;
function login_Login(props) {
    var ref = (0,react.useState)(props.errorMessage), loginError = ref[0], setLoginError = ref[1];
    var requestLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return signin(data.email, data.password);
                    case 3:
                        result = _ctx.sent;
                        if (!result.error) {
                            window.location.href = props.redirect || "/";
                        } else {
                            setLoginError(result.error);
                        }
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        setLoginError("Login failed.");
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function requestLogin(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((Index_module_default()).container, " card-container get-support"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((Index_module_default()).content, " track-request"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            id: "trackrequests",
                            children: "Log In"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginForm, {
                            loginError: loginError,
                            loginRequest: requestLogin
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_FooterLinks, {})
        ]
    });
};


/***/ }),

/***/ 8632:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__Vbh36","copyright":"Footer_copyright__YtgqX","link":"Footer_link__gMKkA"};

/***/ }),

/***/ 10315:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form-actions":"Form_form-actions__Nj41X","save-user":"Form_save-user___W8D4","links":"Form_links__pmkWZ","text-link-children":"Form_text-link-children__gPU8J","subject-required":"Form_subject-required__9RFGt","character-counter":"Form_character-counter__IDhUX","red":"Form_red__H5fY5","count":"Form_count__Kd2Of","login":"Form_login__dvGND","panel":"Form_panel__k_q9g","success-header":"Form_success-header__qQOGr","success-description":"Form_success-description__27zli","success-content":"Form_success-content__wKNyH","success-button":"Form_success-button__io9qv","auth-container":"Form_auth-container__07U0O","form-action":"Form_form-action__n5ngF","description":"Form_description___6wGb","auth-title":"Form_auth-title__m_k6Q"};

/***/ }),

/***/ 78378:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Index_container___Mo47","getSupport":"Index_getSupport__w810m","description":"Index_description__Ii_qc","content":"Index_content__Worm8","kwnoledgeBaseContainer":"Index_kwnoledgeBaseContainer__vQZfz","gray-text":"Index_gray-text__iioA0","link-purple":"Index_link-purple__X0Fxv","login-panel":"Index_login-panel__Wllfn"};

/***/ }),

/***/ 87383:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__f8c9j","ennead":"Layout_ennead__4QtHa","ipg":"Layout_ipg__9MZ8k","v-top":"Layout_v-top__LMVjn","v-middle":"Layout_v-middle__V1eX_","v-bottom":"Layout_v-bottom__GzOBU","main":"Layout_main__U7yw4"};

/***/ }),

/***/ 31757:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top-nav":"TopNav_top-nav__DsYbg","bundle-icon":"TopNav_bundle-icon__QKvho","apps":"TopNav_apps__U3oqE","datagraph":"TopNav_datagraph__iGhm1","app-title":"TopNav_app-title__Zuwm1"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [939,425,774,888,179], function() { return __webpack_exec__(83236); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);